import { useQuery } from '@tanstack/react-query';

import { getMe, ME_QUERY_KEY } from '../api/endpoints/permissions';
import type { FeatureMap } from '../api/schemas';
import { useSession } from '../auth/useSession';

/** Same freshness as a teammate's permissions: a switch Dale flips shows on the next refresh. */
const FEATURES_STALE_MS = 30_000;

export type Features = {
  /** The server's effective map; undefined until it arrives or on an older server. */
  features: FeatureMap | undefined;
  /** False only while the answer is still on its way. */
  ready: boolean;
};

/**
 * The CRM features this business gets: its plan with any override a Dale
 * operator set on top, from `/v1/business/me`. This only hides doors; the
 * API refuses a feature that is off anyway.
 */
export function useFeatures(): Features {
  const { status } = useSession();
  const signedIn = status === 'authenticated';
  const me = useQuery({ queryKey: ME_QUERY_KEY, queryFn: getMe, enabled: signedIn, staleTime: FEATURES_STALE_MS });
  return {
    features: me.data?.data.features,
    ready: !signedIn || me.data !== undefined || me.isError,
  };
}
